import ValuePropImage1 from 'assets/connect/connect-value-prop-1.png';
import ValuePropImage2 from 'assets/connect/connect-value-prop-2.png';
import ValuePropImage3 from 'assets/connect/connect-value-prop-3.png';
import { CAROUSEL_SLIDE_TYPES } from 'utils/constants';

export const CONNECT_ACTION_LABEL = 'Connect with principal';
export const defaultUserLocations = {
  INDIANA: 'Indianapolis, IN',
  MISSOUI: 'St. Louis, MO',
  TENNESSEE: 'Memphis, TN',
};

export const distanceFilterOptions = [
  { value: '5', label: '5 miles' },
  { value: '10', label: '10 miles' },
  { value: '25', label: '25 miles' },
  { value: '50', label: '50 miles' },
  { value: '75', label: '75 miles' },
  { value: '100', label: '100 miles' },
];

export const gradeFilterOptions = [
  { value: 'KG', label: 'Kindergarten' },
  { value: 'PK', label: 'Pre-kindergarten' },
  { value: '1', label: '1st Grade' },
  { value: '2', label: '2nd Grade' },
  { value: '3', label: '3rd Grade' },
  { value: '4', label: '4th Grade' },
  { value: '5', label: '5th Grade' },
  { value: '6', label: '6th Grade' },
  { value: '7', label: '7th Grade' },
  { value: '8', label: '8th Grade' },
  { value: '9', label: '9th Grade' },
  { value: '10', label: '10th Grade' },
  { value: '11', label: '11th Grade' },
  { value: '12', label: '12th Grade' },
];

export const gradePreferencesOptions = [
  { value: 13, label: 'Kindergarten' }, // This is jank, but our API expects 13 for kindergarten 🤷🏾‍♂️
  { value: 0, label: 'Pre-kindergarten' },
  { value: 1, label: '1st Grade' },
  { value: 2, label: '2nd Grade' },
  { value: 3, label: '3rd Grade' },
  { value: 4, label: '4th Grade' },
  { value: 5, label: '5th Grade' },
  { value: 6, label: '6th Grade' },
  { value: 7, label: '7th Grade' },
  { value: 8, label: '8th Grade' },
  { value: 9, label: '9th Grade' },
  { value: 10, label: '10th Grade' },
  { value: 11, label: '11th Grade' },
  { value: 12, label: '12th Grade' },
];

export const connectSubjectOptions = [
  { value: 'business_marketing', label: 'Business & Marketing' },
  { value: 'cte', label: 'Career & Technical Education' },
  { value: 'comp_sci', label: 'Computer Science' },
  { value: 'dance', label: 'Dance' },
  { value: 'early_childhood', label: 'Early Childhood' },
  { value: 'elementary_multiple', label: 'Elementary/Multiple Subjects' },
  { value: 'english_as_second_language', label: 'English as a Second Language (ESL)' },
  { value: 'foreign_language_french', label: 'Foreign Language: French' },
  { value: 'foreign_language_other', label: 'Foreign Language: Other' },
  { value: 'foreign_language_spanish', label: 'Foreign Language: Spanish' },
  { value: 'gifted_education', label: 'Gifted Education' },
  { value: 'health_and_physical_education', label: 'Health & Physical Education' },
  { value: 'language_arts', label: 'Language Arts' },
  { value: 'library_and_media', label: 'Library & Media' },
  { value: 'math', label: 'Mathematics' },
  { value: 'music_choral', label: 'Music: Choral' },
  { value: 'music_general', label: 'Music: Instrumental/general' },
  { value: 'other', label: 'Other' },
  { value: 'reading', label: 'Reading & Literacy' },
  { value: 'science', label: 'Science' },
  { value: 'social_studies', label: 'Social Studies' },
  { value: 'special_education_comprehensive', label: 'Special Education (Comprehensive)' },
  { value: 'special_education_general', label: 'Special Education (General)' },
  { value: 'theater', label: 'Theater' },
  { value: 'visual_arts', label: 'Visual Arts' },
];

export const valuePropSlides = [
  {
    type: CAROUSEL_SLIDE_TYPES.QUOTE,
    quote:
      '"I love that there are so many features included - job description, salary scale, map, days in workweek, ability to connect with leadership quickly - all in one place! Awesome time-savers."',
    authorName: 'Julie B.',
    authorJobTitle: 'Teacher in St. Louis, MO',
  },
  {
    type: CAROUSEL_SLIDE_TYPES.IMAGE_WITH_TEXT,
    title: 'Connect directly with principals',
    description:
      "Avoid dozens of long tedious applications. Share your qualifications directly with principals to get quick feedback on whether it's a fit.",
    image: ValuePropImage1,
  },
  {
    type: CAROUSEL_SLIDE_TYPES.IMAGE_WITH_TEXT,
    title: 'Schedule an intro call in just a few days',
    description:
      "Mark yourself as open to contact and fill out your profile - we'll match you with principals whose schools meet your criteria. If it's a good match, the principal will contact you via email.",
    image: ValuePropImage2,
  },
  {
    type: CAROUSEL_SLIDE_TYPES.IMAGE_WITH_TEXT,
    title: 'Be the first to know about teaching jobs',
    description:
      "See all state teaching jobs in one place. Save schools you're interested in and receive alerts when they post new jobs that meet your criteria.",
    image: ValuePropImage3,
  },
];
